import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { logUserLogout, redirectToLogin } from '../../utils';
import useDebounce from '../../utils/debounce';
import { CenteredProgress } from '../index';

export const NoContainersMessage = () => {
  const { t } = useTranslation();
  const [debounceTime] = useDebounce(() => {
    void logUserLogout('no_container_found_on_account');
    void redirectToLogin();
  }, 10000);

  useEffect(() => {
    debounceTime();
  });

  return (
    <Box>
      <Alert severity="error">{t('common:message-no-containers')}</Alert>
      <CenteredProgress />
    </Box>
  );
};
